import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../lib/Icon';
import { useUser } from '../../contexts/ContextUser';

function NewEngagementCard() {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate('/console/new')}
      style={{
        appearance: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column',
        alignItems: 'flex-start', justifyContent: 'center', gap: 10, padding: '24px',
        borderRadius: 'var(--radius-lg)', border: '1.5px dashed var(--line-strong)',
        background: 'transparent', textAlign: 'left', minHeight: 200,
      }}
      onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'var(--science-500)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--line-strong)'; }}
    >
      <span style={{
        display: 'inline-flex', width: 40, height: 40, alignItems: 'center', justifyContent: 'center',
        borderRadius: 'var(--radius-md)', background: 'var(--science-100)', color: 'var(--science-700)',
      }}>
        <Icon name="plus" size={20} />
      </span>
      <div style={{ fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-bold)', fontSize: 'var(--text-h4)', letterSpacing: 'var(--track-tight)' }}>
        Start an engagement
      </div>
      <div style={{ fontSize: 'var(--text-sm)', color: 'var(--ink-muted)', maxWidth: '34ch' }}>
        Add any number of assessments for a cohort and track them in one place.
      </div>
    </button>
  );
}

/** Foundation placeholder for the My Engagements dashboard (sub-project 3 wires real data). */
export default function EngagementsHome() {
  const { user } = useUser();
  const hour = new Date().getHours();
  const daypart = hour < 12 ? 'morning' : hour < 18 ? 'afternoon' : 'evening';
  return (
    <div style={{ padding: '30px 36px 56px', display: 'flex', flexDirection: 'column', gap: 28, maxWidth: 1240, width: '100%', margin: '0 auto', boxSizing: 'border-box' }}>
      <div>
        <div className="cc-eyebrow" style={{ marginBottom: 6 }}>Good {daypart}, {user.first_name}</div>
        <h1 style={{ margin: 0, fontSize: 'var(--text-h2)', letterSpacing: 'var(--track-display)' }}>My engagements</h1>
        <p className="cc-prose" style={{ margin: '6px 0 0', color: 'var(--ink-soft)', fontSize: 'var(--text-base)', maxWidth: '62ch' }}>
          Each engagement runs a series of assessments for one cohort. Track completion, send reminders,
          and pull reports as the program moves forward.
        </p>
      </div>
      <div className="cc-eng-grid">
        <NewEngagementCard />
      </div>
    </div>
  );
}
